import { createSelector } from '@reduxjs/toolkit';
import { selectIsUserFreemium } from 'store/selectors/app-selectors';

export const ACADEMY_URL = 'https://academy.placer.ai';
export const ACADEMY_DOMAIN = 'https://connect.placer.ai';
const ACADEMY_SRC = `${ACADEMY_DOMAIN}/academy/home`;
const ACADEMY_FREEMIUM_SRC = `${ACADEMY_DOMAIN}/academy/home-freemium`;

export const selectAcademyIframeSrc = createSelector(selectIsUserFreemium, (isUserFreemium) => {
    if (isUserFreemium) {
        return ACADEMY_FREEMIUM_SRC;
    } else {
        return ACADEMY_SRC;
    }
});
